import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from "../../assets/New_Img/logo 1.png";

const Sidebar = () => {
    const [isReportsOpen, setIsReportsOpen] = useState(true);
    const location = useLocation();
    const toggleReports = () => {
        setIsReportsOpen(!isReportsOpen);
    };

    const isActive = (path) => location.pathname === path;

    useEffect(() => {
        const reportPaths = [
            "/sales_enrollment_report",
            "/sales_qr_transaction_report",
            "/sales_success_qr_transaction_report",
            "/sales_error_qr_transaction_report",
            "/sales_reversed_qr_transaction_report",
            "/sales_ticket_report",
            "/redemption_report",
            "/new_enrollment_report"
        ];
        if (reportPaths.includes(location.pathname)) {
            setIsReportsOpen(true);
        }
    }, [location.pathname]);

    /* ===== FONT STYLES ===== */
    const menuTextStyle = {
        fontWeight: 500,
        fontSize: '14px'
    };

    const activeStyle = {
        backgroundColor: '#2eb545',
        color: '#fff',
        borderRadius: '5px',
        fontWeight: 600
    };

    const inactiveStyle = {
        color: '#6c757d',
        fontWeight: 500
    };

    return (
        <div
            className="d-flex flex-column p-3 text-white d-none d-lg-flex"
            style={{
                width: '250px',
                backgroundColor: '#ffffff',
                borderRight: '1px solid #e0e0e0',
                minHeight: '100vh',
                color: '#333'
            }}
        >
            {/* LOGO */}
            <div className="d-flex align-items-center mb-4 ps-2">
                <div className="fw-bold fs-4 text-success d-flex align-items-center">
                    <img src={logo} style={{ width: "200px" }} alt="Logo" />
                </div>
            </div>

            {/* MENU */}
            <ul className="nav nav-pills flex-column mb-auto">

                {/* Dashboard */}
                <li className="nav-item mb-2">
                    <Link
                        to="/sales_dashboard"
                        className="nav-link d-flex align-items-center"
                        style={{
                            ...(isActive('/sales_dashboard') ? activeStyle : inactiveStyle),
                            ...menuTextStyle
                        }}
                    >
                        <i className="bi bi-house-door-fill me-2"></i>
                        Dashboard
                    </Link>
                </li>

                {/* Pending Approval */}
                <li className="nav-item mb-2">
                    <Link
                        to="/pending_retailer"
                        className="nav-link d-flex align-items-center"
                        style={{
                            ...(isActive('/pending_retailer') ? activeStyle : inactiveStyle),
                            ...menuTextStyle
                        }}
                    >
                        <i className="bi bi-person-exclamation me-2"></i>
                        Pending Approval
                    </Link>
                </li>

                {/* Approved Retailers */}
                <li className="nav-item mb-2">
                    <Link
                        to="/approved_retailer"
                        className="nav-link d-flex align-items-center"
                        style={{
                            ...(isActive('/approved_retailer') ? activeStyle : inactiveStyle),
                            ...menuTextStyle
                        }}
                    >
                        <i className="bi bi-person-check me-2"></i>
                        Approved Retailers
                    </Link>
                </li>

                {/* Rejected Retailers */}
                <li className="nav-item mb-2">
                    <Link
                        to="/rejected_retailer"
                        className="nav-link d-flex align-items-center"
                        style={{
                            ...(isActive('/rejected_retailer') ? activeStyle : inactiveStyle),
                            ...menuTextStyle
                        }}
                    >
                        <i className="bi bi-person-x me-2"></i>
                        Rejected Retailers
                    </Link>
                </li>

                {/* REPORTS DROPDOWN */}
                <li className="nav-item mb-2">
                    <div
                        className="nav-link d-flex align-items-center justify-content-between"
                        onClick={toggleReports}
                        style={{
                            cursor: 'pointer',
                            fontWeight: isReportsOpen ? 600 : 500,
                            fontSize: '14px',
                            color: isReportsOpen ? '#4E7C48' : '#6c757d'
                        }}
                    >
                        <div className="d-flex align-items-center">
                            <i className="bi bi-file-earmark-text me-2"></i>
                            Reports
                        </div>
                        <i className={`bi bi-chevron-${isReportsOpen ? 'up' : 'down'} small`}></i>
                    </div>

                    {isReportsOpen && (
                        <ul className="nav flex-column ms-3 mt-1 border-start ps-2" style={{ borderColor: '#e0e0e0' }}>
                            <li className="nav-item">
                                <Link
                                    to="/sales_enrollment_report"
                                    className="nav-link py-1 small"
                                    style={{
                                        fontWeight: isActive('/sales_enrollment_report') ? 600 : 500,
                                        color: isActive('/sales_enrollment_report') ? '#2eb545' : '#6c757d',
                                        fontSize: '11px',
                                    }}
                                >
                                    Enrollment Report
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    to="/new_enrollment_report"
                                    className="nav-link py-1 small"
                                    style={{
                                        fontWeight: isActive('/new_enrollment_report') ? 600 : 500,
                                        color: isActive('/new_enrollment_report') ? '#2eb545' : '#6c757d',
                                        fontSize: '11px',
                                    }}
                                >
                                    New Enrollment Report
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    to="/sales_qr_transaction_report"
                                    className="nav-link py-1 small"
                                    style={{
                                        fontWeight: isActive('/sales_qr_transaction_report') ? 600 : 500,
                                        color: isActive('/sales_qr_transaction_report') ? '#2eb545' : '#6c757d', fontSize: '11px',
                                    }}
                                >
                                    QR Transaction Report
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    to="/sales_success_qr_transaction_report"
                                    className="nav-link py-1 small"
                                    style={{
                                        fontWeight: isActive('/sales_success_qr_transaction_report') ? 600 : 500,
                                        color: isActive('/sales_success_qr_transaction_report') ? '#2eb545' : '#6c757d', fontSize: '11px',
                                    }}
                                >
                                    Success QR Transaction Report
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    to="/sales_error_qr_transaction_report"
                                    className="nav-link py-1 small"
                                    style={{
                                        fontWeight: isActive('/sales_error_qr_transaction_report') ? 600 : 500,
                                        color: isActive('/sales_error_qr_transaction_report') ? '#2eb545' : '#6c757d', fontSize: '11px',
                                    }}
                                >
                                    Error QR Transaction Report
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    to="/sales_reversed_qr_transaction_report"
                                    className="nav-link py-1 small"
                                    style={{
                                        fontWeight: isActive('/sales_reversed_qr_transaction_report') ? 600 : 500,
                                        color: isActive('/sales_reversed_qr_transaction_report') ? '#2eb545' : '#6c757d', fontSize: '11px',
                                    }}
                                >
                                    Reversed QR Transaction Report
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    to="/sales_ticket_report"
                                    className="nav-link py-1 small"
                                    style={{
                                        fontWeight: isActive('/sales_ticket_report') ? 600 : 500,
                                        color: isActive('/sales_ticket_report') ? '#2eb545' : '#6c757d', fontSize: '11px',
                                    }}
                                >
                                    Ticket Report
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    to="/redemption_report"
                                    className="nav-link py-1 small"
                                    style={{
                                        fontWeight: isActive('/redemption_report') ? 600 : 500,
                                        color: isActive('/redemption_report') ? '#2eb545' : '#6c757d', fontSize: '11px',
                                    }}
                                >
                                    Redemption Report
                                </Link>
                            </li>

                        </ul>
                    )}
                </li>
            </ul>
        </div>
    );
};

export default Sidebar;
